import {
  LoadingStatusType,
  TypeComponentNoti,
  WhtCertificateStatus,
  WhtCertificateTableViewStatusType,
} from "@/enums/enums";
import { GetMessageExceptionCode } from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import {
  ConvertToInsertWhtCertificateModel,
  ConvertToQuickInsertWHTCertificateModel,
  SetAlertMessageErrorQuickCreateWHT,
  SetHeaderWhtCertificateTable,
  SetTapsWhtCertificateTable,
  ValidateInsertWhtCertificateTemplate,
  ValidateQuickCreateWHTTemplate,
} from "@/helper/withholdingHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import API from "@/service/Index";
import { ConvertToWhtDetailData, ConvertToWhtDetailListForPnd, SliceArrayData } from "@/service/pnd/pndFacade";
import {
  ConvertToWhtCertificateDetail,
  ConvertToWithholdingTaxTableAdvanceSearch,
  GetContactIdListForPrepareWithholdingTax,
} from "@/service/withholding/withholdingFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
export default class Withholding extends VuexModule {
  public quickInsertWhtCertificate: LoadingStatusType = LoadingStatusType.None;
  public fetchDataWhtLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public numberOfFetchDataWht = 0;
  public suggestNumberWhtLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public suggestNumberWht: any = null;
  public tableWhtCertificateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tapsWhtCertificateTable: any = [];
  public headerWhtCertificateTable: any = [];
  public whtCertificateTableList: any = [];
  public whtCertificateDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateDetail: any = null;
  public insertWhtCertificateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tableCountWhtCertificate: any = null;
  public tableCountWhtCertificateLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public sendEmailTransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtSuggestHeader = "";
  public whtSuggestHeaderLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtDetailForUpdateWht: any = null;
  public whtDetailForUpdateWhtLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtDetailListForPnd: any = null;
  public whtDetailListForPndLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateByLastCreateDateTimeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public whtCertificateByLastCreateDateTimeModel: any = null;
  public whtCertificateFromQuickCreate: any = null;
  public whtCertificateResponse: any = null;
  public whtCertificateFetchData: any = null;

  get getWhtCertificateResponse(): LoadingStatusType {
    return this.whtCertificateResponse;
  }
  get getQuickInsertWhtCertificate(): LoadingStatusType {
    return this.quickInsertWhtCertificate;
  }
  get getFetchDataWhtLoadingStatus(): LoadingStatusType {
    return this.fetchDataWhtLoadingStatus;
  }
  get getNumberOfFetchDataWht(): number {
    return this.numberOfFetchDataWht;
  }
  get getWhtCertificateFetchData(): any {
    return this.whtCertificateFetchData;
  }
  get getTableWhtCertificateLoadingStatus(): LoadingStatusType {
    return this.tableWhtCertificateLoadingStatus;
  }
  get getWhtCertificateByLastCreateDateTimeLoadingStatus(): LoadingStatusType {
    return this.whtCertificateByLastCreateDateTimeLoadingStatus;
  }
  get getWhtCertificateByLastCreateDateTimeModel(): any {
    return this.whtCertificateByLastCreateDateTimeModel;
  }
  get getTapsWhtCertificateTable(): any {
    return this.tapsWhtCertificateTable;
  }
  get getHeaderWhtCertificateTable(): any {
    return this.headerWhtCertificateTable;
  }
  get getWhtCertificateTableList(): any {
    return this.whtCertificateTableList;
  }
  get getSuggestNumberWhtLoadingStatus(): LoadingStatusType {
    return this.suggestNumberWhtLoadingStatus;
  }
  get getSuggestNumberWht(): any {
    return this.suggestNumberWht;
  }
  get getWhtCertificateDetailLoadingStatus(): LoadingStatusType {
    return this.whtCertificateDetailLoadingStatus;
  }
  get getWhtCertificateDetail(): any {
    return this.whtCertificateDetail;
  }
  get getInsertWhtCertificateLoadingStatus(): LoadingStatusType {
    return this.insertWhtCertificateLoadingStatus;
  }
  get getTableCountWhtCertificate(): any {
    return this.tableCountWhtCertificate;
  }
  get getTableCountWhtCertificateLoadingStatus(): LoadingStatusType {
    return this.tableCountWhtCertificateLoadingStatus;
  }
  get getSendEmailTransactionLoadingStatus(): LoadingStatusType {
    return this.sendEmailTransactionLoadingStatus;
  }
  get getWhtSuggestHeader(): any {
    return this.whtSuggestHeader;
  }
  get getWhtSuggestHeaderLoadingStatus(): LoadingStatusType {
    return this.whtSuggestHeaderLoadingStatus;
  }
  get getWhtDetailForUpdateWht(): any {
    return this.whtDetailForUpdateWht;
  }
  get getWhtDetailForUpdateWhtLoadingStatus(): LoadingStatusType {
    return this.whtDetailForUpdateWhtLoadingStatus;
  }
  get getWhtDetailListForPnd(): any {
    return this.whtDetailListForPnd;
  }
  get getWhtDetailListForPndLoadingStatus(): LoadingStatusType {
    return this.whtDetailListForPndLoadingStatus;
  }
  get getWhtCertificateFromQuickCreate(): any {
    return this.whtCertificateFromQuickCreate;
  }

  @Mutation
  public SetSendEmailTransactionLoadingStatus(status: LoadingStatusType) {
    this.sendEmailTransactionLoadingStatus = status;
  }
  @Mutation
  public SetWhtCertificateByLastCreateDateTimeLoadingStatus(status: LoadingStatusType) {
    this.whtCertificateByLastCreateDateTimeLoadingStatus = status;
  }

  @Mutation
  public MutationGetWhtCertificateByLastCreateDateTimeModel(inputModel: any) {
    this.whtCertificateByLastCreateDateTimeModel = inputModel;
  }
  @Mutation
  public SetTableWhtCertificateLoadingStatus(status: LoadingStatusType) {
    this.tableWhtCertificateLoadingStatus = status;
  }
  @Mutation
  public SetFetchDataWhtLoadingStatus(status: LoadingStatusType) {
    this.fetchDataWhtLoadingStatus = status;
  }
  @Mutation
  public SetNumberOfFetchDataWht(number: number) {
    this.numberOfFetchDataWht = number;
  }
  @Mutation
  public SetWhtCertificateResponse(response: any) {
    this.whtCertificateResponse = response;
  }
  @Mutation
  public SetWhtCertificateFetchData(response: any) {
    this.whtCertificateFetchData = response;
  }
  @Mutation
  public MutationGetWhtCertificateTable(whtCertificateTable: any) {
    this.whtCertificateTableList = whtCertificateTable.tableList;
  }
  @Mutation
  public MutationGetWhtCertificateTableAdvanceSearch(whtCertificateTableList: Array<any>) {
    this.whtCertificateTableList = whtCertificateTableList;
  }
  @Mutation
  public SetHeaderWhtCertificateTable(input: any) {
    this.headerWhtCertificateTable = SetHeaderWhtCertificateTable();

    if (input.sorting !== null) {
      this.headerWhtCertificateTable.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  public SetQuickInsertWhtCertificateLoadingStatus(status: LoadingStatusType) {
    this.quickInsertWhtCertificate = status;
  }

  @Mutation
  public SetInsertWhtCertificateLoadingStatus(status: LoadingStatusType) {
    this.insertWhtCertificateLoadingStatus = status;
  }

  @Mutation
  public SetSuggestNumberWht(suggestNumberWht: string) {
    this.suggestNumberWht = suggestNumberWht;
  }

  @Mutation
  public SetSuggestNumberWhtLoadingStatus(status: LoadingStatusType) {
    this.suggestNumberWhtLoadingStatus = status;
  }

  @Mutation
  public SetWhtCertificateDetailLoadingStatus(status: LoadingStatusType) {
    this.whtCertificateDetailLoadingStatus = status;
  }

  @Mutation
  public SetWhtCertificateDetail(whtCertificateDetail: any) {
    this.whtCertificateDetail = whtCertificateDetail;
  }

  @Mutation
  public SetTableCountWhtCertificateLoadingStatus(status: LoadingStatusType) {
    this.tableCountWhtCertificateLoadingStatus = status;
  }

  @Mutation
  public SetTableCountWhtCertificate(table: any) {
    this.tapsWhtCertificateTable = SetTapsWhtCertificateTable(table.tableView, table.tableCount);
    this.tableCountWhtCertificate = table;
  }

  @Mutation
  public SetWhtSuggestHeader(whtSuggestHeader: string) {
    this.whtSuggestHeader = whtSuggestHeader;
  }

  @Mutation
  public SetWhtSuggestHeaderLoadingStatus(status: LoadingStatusType) {
    this.whtSuggestHeaderLoadingStatus = status;
  }

  @Mutation
  public SetWhtDetailForUpdateWht(whtDetailForUpdateWht: any) {
    this.whtDetailForUpdateWht = whtDetailForUpdateWht;
  }

  @Mutation
  public SetWhtDetailForUpdateWhtLoadingStatus(status: LoadingStatusType) {
    this.whtDetailForUpdateWhtLoadingStatus = status;
  }

  @Mutation
  public SetWhtDetailListForPnd(whtDetailListForPnd: any) {
    this.whtDetailListForPnd = whtDetailListForPnd;
  }

  @Mutation
  public SetWhtDetailListForPndLoadingStatus(status: LoadingStatusType) {
    this.whtDetailListForPndLoadingStatus = status;
  }

  @Mutation
  public SetWhtCertificateFromQuickCreate(whtCertificate: any) {
    this.whtCertificateFromQuickCreate = whtCertificate;
    this.whtCertificateFromQuickCreate.whtItemModelList = [
      {
        description: whtCertificate.description.value,
        preTaxAmount: whtCertificate.netAmount.value.ToNumber(),
        taxIncomeType: whtCertificate.incomeType.value.id,
        whtAmount: whtCertificate.whtAmount.value,
        whtRate: whtCertificate.whtRateType.value.value,
      },
    ];
  }

  @Mutation
  public ResetWhtCertificateFromQuickCreate() {
    this.whtCertificateFromQuickCreate = null;
  }

  @Action
  public DoGetTableWhtCertificateAdvanceSearchDefault(input: any) {
    if (this.tableWhtCertificateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTableWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoGetTableWhtCertificateAdvanceSearchDefault(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPrepareWithholdingTax(res.data.data);
          const headerTableWhtCertificate = {
            sortBy: input.whtCertificateTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tableWhtCertificateList = ConvertToWithholdingTaxTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("MutationGetWhtCertificateTableAdvanceSearch", tableWhtCertificateList);
          this.context.commit("SetHeaderWhtCertificateTable", headerTableWhtCertificate);
        }
        this.context.commit("SetTableWhtCertificateLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetTableWhtCertificateAdvanceSearch(input: any) {
    if (this.tableWhtCertificateLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTableWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoGetTableWhtCertificateAdvanceSearch(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPrepareWithholdingTax(res.data.data);
          const headerTableWhtCertificate = {
            sortBy: input.whtCertificateTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tableWhtCertificateList = ConvertToWithholdingTaxTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("MutationGetWhtCertificateTableAdvanceSearch", tableWhtCertificateList);
          this.context.commit("SetHeaderWhtCertificateTable", headerTableWhtCertificate);
        }
        this.context.commit("SetTableWhtCertificateLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetTableCountWhtCertificateAdvanceSearch(input: any) {
    if (this.tableCountWhtCertificate !== LoadingStatusType.Loading) {
      this.context.commit("SetTableCountWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoGetTableCountWhtCertificateAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tableCountWhtCertificate = {
            tableCount: res.data.data,
            tableView: input.whtCertificateTableViewStatusType,
          };
          this.context.commit("SetTableCountWhtCertificate", tableCountWhtCertificate);
        }
        this.context.commit("SetTableCountWhtCertificateLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetWhtCertificateByLastCreateDateTime(input: any) {
    if (this.whtCertificateByLastCreateDateTimeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtCertificateByLastCreateDateTimeLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoGetWhtCertificateByLastCreateDateTime(input).then((res) => {
        this.context.commit("MutationGetWhtCertificateByLastCreateDateTimeModel", res.data.data);
        this.context.commit("SetWhtCertificateByLastCreateDateTimeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoQuickInsertWhtCertificate(input: any) {
    const validated = ValidateQuickCreateWHTTemplate(input.quickCreateWHTTemplate);
    if (validated) {
      const quickInsertWHTCertificate = ConvertToQuickInsertWHTCertificateModel(input.quickCreateWHTTemplate);
      if (this.quickInsertWhtCertificate !== LoadingStatusType.Loading) {
        this.context.commit("SetQuickInsertWhtCertificateLoadingStatus", LoadingStatusType.Loading);
        API.WithholdingService.QuickInsertWhtCertificate(quickInsertWHTCertificate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (input.isRedirect) {
              router.push({
                name: "withholdingDetail",
                query: { emi: MerchantId().PeakEncryption(), eii: res.data.data.id.PeakEncryption() },
              });
            }

            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Create_WHT_Certificate_Success", { msg: res.data.data.whtNumber }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetQuickInsertWhtCertificateLoadingStatus", LoadingStatusType.Success);
        });
      }
    } else {
      SetAlertMessageErrorQuickCreateWHT(input.quickCreateWHTTemplate);
    }
  }

  @Action
  public DoFetchDataWht(input: any) {
    const prepareInput = {
      language: i18n.locale,
      paymentFlowType: input.paymentFlowType,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isExceptItemFiled: input.isExceptItemFiled,
    };
    if (this.fetchDataWhtLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoFetchDataWht(prepareInput).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data && res.data.data.length > 0) {
            this.context.commit("SetNumberOfFetchDataWht", res.data.data.length);
          } else {
            this.context.commit("SetNumberOfFetchDataWht", 0);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Fetch_Data_Not_Found", { name: i18n.t("WHT") }),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoFetchDataWhtForNumber(input: any) {
    if (this.fetchDataWhtLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.DoFetchDataWhtForNumber(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data && res.data.data.length > 0) {
            this.context.commit("SetWhtCertificateFetchData", res.data.data);
            this.context.commit("SetNumberOfFetchDataWht", res.data.data.length);
          } else {
            this.context.commit("SetNumberOfFetchDataWht", 0);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Fetch_Data_Not_Found", { name: i18n.t("WHT") }),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetFetchDataWhtLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoInsertWhtCertificate(insertWhtCertificateTemplate: any) {
    const validated = ValidateInsertWhtCertificateTemplate(insertWhtCertificateTemplate);

    if (validated.validated) {
      if (this.insertWhtCertificateLoadingStatus !== LoadingStatusType.Loading) {
        const InsertWhtCertificate = ConvertToInsertWhtCertificateModel(insertWhtCertificateTemplate);
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Loading);
        API.WithholdingService.InsertWhtCertificate(InsertWhtCertificate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (insertWhtCertificateTemplate.status < WhtCertificateStatus.AwaitFiling) {
              router.push({ name: "withholding", query: { emi: MerchantId().PeakEncryption() } });
            } else {
              router.push({
                name: "withholdingDetail",
                query: { emi: MerchantId().PeakEncryption(), eii: res.data.data.id.PeakEncryption() },
              });
            }
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Create_WHT_Certificate_Success", { msg: res.data.data.whtNumber }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(validated.textError),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
    }
  }

  @Action
  public UpdateWhtCertificate(insertWhtCertificateTemplate: any) {
    const validated = ValidateInsertWhtCertificateTemplate(insertWhtCertificateTemplate);

    if (validated.validated) {
      if (this.insertWhtCertificateLoadingStatus !== LoadingStatusType.Loading) {
        const updateWHTCertificate = ConvertToInsertWhtCertificateModel(insertWhtCertificateTemplate);
        this.context.dispatch("Loading/IsLoading", true, { root: true });
        this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Loading);
        API.WithholdingService.UpdateWhtCertificate(updateWHTCertificate).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            if (insertWhtCertificateTemplate.status < WhtCertificateStatus.AwaitFiling) {
              router.push({ name: "withholding", query: { emi: MerchantId().PeakEncryption() } });
            } else {
              router.push({
                name: "withholdingDetail",
                query: { emi: MerchantId().PeakEncryption(), eii: res.data.data.id.PeakEncryption() },
              });
            }
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Updated_WHT_Certificate_Success", { msg: res.data.data.whtNumber }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t(validated.textError),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
    }
  }

  @Action
  public QuickEditWhtCertificate(insertWhtCertificateTemplate: any) {
    if (this.insertWhtCertificateLoadingStatus !== LoadingStatusType.Loading) {
      const updateWHTCertificate = ConvertToInsertWhtCertificateModel(insertWhtCertificateTemplate);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.UpdateWhtCertificate(updateWHTCertificate).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Updated_WHT_Certificate_Success", { msg: res.data.data.whtNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetInsertWhtCertificateLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }

  @Action
  public DoGetSuggestNumberWhtModel(input: any) {
    this.context.commit("SetSuggestNumberWhtLoadingStatus", LoadingStatusType.Loading);
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.WithholdingService.GetSuggestNumberWhtModel(input).then((res) => {
      this.context.commit("SetSuggestNumberWht", res.data.data);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
      this.context.commit("SetSuggestNumberWhtLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  public DoGetWhtSuggestHeaderByPndType(input: any) {
    this.context.commit("SetWhtSuggestHeaderLoadingStatus", LoadingStatusType.Loading);
    API.WithholdingService.GetWhtSuggestHeaderByPndType(input).then((res) => {
      this.context.commit("SetWhtSuggestHeader", res.data.data);

      this.context.commit("SetWhtSuggestHeaderLoadingStatus", LoadingStatusType.Success);
    });
  }

  @Action
  public DoGetWhtCertificateDetail(id: any) {
    if (this.whtCertificateDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtCertificateDetailLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.WithholdingService.GetDetailWhtCertificate(id).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data.contactId > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", [res.data.data.contactId], { root: true });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          if (contactList && contactList.length > 0) {
            const whtCertificateDetail = ConvertToWhtCertificateDetail(res.data.data, contactList);
            this.context.commit("SetWhtCertificateDetail", whtCertificateDetail);

            this.context.commit("SetWhtCertificateDetailLoadingStatus", LoadingStatusType.Success);
            this.context.dispatch("Loading/IsLoading", false, { root: true });
          }
        } else {
          this.context.commit("SetWhtCertificateResponse", res.data.responseCode);
          this.context.commit("SetWhtCertificateDetailLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoVoidWhtCertificate(input: any) {
    this.context.dispatch("Loading/IsLoading", true, { root: true });
    API.WithholdingService.VoidWhtCertificate(input.id).then((res) => {
      if (res.data.responseCode.IsSuccess()) {
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: i18n.t("Voided_WHT_Certificate_Success", { msg: res.data.data.whtNumber }),
            typeMessage: TypeComponentNoti.Success,
          },
          { root: true }
        );
        router.push({
          name: "withholding",
          query: { emi: MerchantId().PeakEncryption(), stid: WhtCertificateTableViewStatusType.Voided.toString() },
        });
      } else {
        const alertMessage = GetMessageExceptionCode(res.data.exception);
        this.context.dispatch(
          "Alert/SetAlertMessage",
          {
            alertMessage: alertMessage,
            typeMessage: TypeComponentNoti.Error,
          },
          { root: true }
        );
      }
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    });
  }

  @Action
  DoSendEmailTransaction(input: any) {
    if (this.sendEmailTransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetSendEmailTransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.WithholdingService.DoUpdateDocumentWhtCertificate(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          API.WithholdingService.DoSendEmailTransaction(input).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Send_WHT_Certificate_Success", { msg: input.documentNumber }),
                  typeMessage: TypeComponentNoti.success,
                },
                { root: true }
              );
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.dispatch("Loading/IsLoading", false, { root: true });
            this.context.commit("SetSendEmailTransactionLoadingStatus", LoadingStatusType.Success);
          });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.commit("SetSendEmailTransactionLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public async DoGetPeakWhtList(input: any) {
    if (this.whtDetailListForPndLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtDetailListForPndLoadingStatus", LoadingStatusType.Loading);
      const resDataList: any = [];
      const maxSliceArray = 1000;
      const idSliceList = SliceArrayData(input, maxSliceArray);
      for (let count = 0; count < idSliceList.length; count++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        await API.WithholdingService.GetPeakWhtList(idSliceList[count]).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const _whtList = res.data.data;
            if (_whtList && _whtList.length > 0) {
              _whtList.forEach((_whtItem: any) => {
                const wht = ConvertToWhtDetailData(_whtItem);
                resDataList.push(wht);
              });
            }
          }
        });
      }
      this.context.commit("SetWhtDetailListForPnd", resDataList);
      this.context.commit("SetWhtDetailListForPndLoadingStatus", LoadingStatusType.Success);
    }
  }

  @Action
  public DoGetPeakWhtListForUpdateWht(input: any) {
    if (this.whtDetailForUpdateWhtLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetWhtDetailForUpdateWhtLoadingStatus", LoadingStatusType.Loading);
      API.WithholdingService.GetPeakWhtList(input.idList).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const whtList = ConvertToWhtDetailListForPnd(res.data.data);
          this.context.commit("SetWhtDetailForUpdateWht", whtList[0]);

          if (this.whtCertificateDetailLoadingStatus !== LoadingStatusType.Loading) {
            this.context.dispatch("Loading/IsLoading", true, { root: true });
            API.WithholdingService.GetDetailWhtCertificate(input.whtId).then(async (res) => {
              if (res.data.responseCode.IsSuccess()) {
                if (res.data.data.contactId > 0) {
                  await store.dispatch("Contact/DoGetContactByContactIdList", [res.data.data.contactId], {
                    root: true,
                  });
                }
                const contactList = store.getters["Contact/getContactModelList"];
                if (contactList && contactList.length > 0) {
                  const whtCertificateDetail = ConvertToWhtCertificateDetail(res.data.data, contactList);
                  this.context.commit("SetWhtCertificateDetail", whtCertificateDetail);
                }
              }
              this.context.commit("SetWhtDetailForUpdateWhtLoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
        }
      });
    }
  }
}
